(function () {
	const header = () => {
		const body = document.querySelector("body");
		const header = document.querySelector(".shopify-section-header");
		const headerDetails = document.querySelector(".menu-drawer-container");
		const headerIsAlwaysSticky =
			header
				.querySelector(".header-wrapper")
				.getAttribute("data-sticky-type") === "always";

		headerDetails.addEventListener("toggle", function (e) {
			const colorScheme =
				this.querySelector("#menu-drawer").dataset.colorScheme;
			header.classList.toggle(colorScheme);
		});

		document.addEventListener("keyup", (e) => {
			if (e.key === "Escape") {
				header.classList.remove("shopify-section-header-sticky", "animate");
				body.classList.remove("overflow-hidden");
			}
		});
      
document.addEventListener("DOMContentLoaded", function () {
    let lastScrollTop = 0;
    const header = document.querySelector(".shopify-section-header");

    if (!header) {
        console.error("Header element not found!");
        return;
    }

    window.addEventListener("scroll", function () {
        let scrollTop = window.scrollY || document.documentElement.scrollTop;

        if (scrollTop > lastScrollTop) {
            // Scrolling Down - Hide header
            header.classList.add("hide-header");
        } else {
            // Scrolling Up - Show header
            header.classList.remove("hide-header");
        }
        lastScrollTop = scrollTop <= 0 ? 0 : scrollTop;
    });
});

		//$(".mega-menu-details summary").click(function (e) {
		//	e.preventDefault();
		//	const attrOpen = $(this).attr("open");
		//	if (attrOpen === false || attrOpen === undefined) {
		//		console.log(attrOpen);
		//		//$(".mega-menu-details").removeAttr("open");
		//		//$(this).attr("open", "open");
		//	} else {
		//		$(".mega-menu-details").removeAttr("open");
		//	}
		//});

		$(".header__icon--account").click(function (e) {
			$(".search-modal").removeClass("active");
		});

		const announcementBar = document.querySelector(".announcement-bar");
		const headerOffcanvas = document.querySelector(".burger-drawer");
		const headerOverlayWithBackground = document.querySelector('[data-overlay-with-background]')?.dataset.overlayWithBackground === 'true';

		announcementBar &&
			headerOffcanvas &&
			headerOffcanvas.classList.add("announcement-bar-show");

		$(window).scroll(function () {
			if ($(window).scrollTop() > 100) {
				announcementBar &&
					headerOffcanvas &&
					headerOffcanvas.classList.add("announcement-bar-hide");
				announcementBar &&
					headerOffcanvas &&
					headerOffcanvas.classList.remove("announcement-bar-show");
			} else {
				announcementBar &&
					headerOffcanvas &&
					headerOffcanvas.classList.remove("announcement-bar-hide");
				announcementBar &&
					headerOffcanvas &&
					headerOffcanvas.classList.add("announcement-bar-show");
			}
		});
		$(".shopify-section-header").hover(
			function () {
				if (
					!$(".burger-drawer").hasClass("active") ||
					!$("#search-modal").hasClass("active")
				) {
					if (!headerOverlayWithBackground) {
						$(".shopify-section-header").addClass("color-background-1");
					}
					
				}
			},
			function () {
				if (
					$(".burger-drawer").hasClass("active") ||
					$("#search-modal").hasClass("active")
				) {
					if (!headerOverlayWithBackground) {
						$(".shopify-section-header").addClass("color-background-1");
					}
					
				} else {
					$(".shopify-section-header").removeClass("color-background-1");
				}
			}
		);
	};
	document.addEventListener("shopify:section:load", header);
	header();
})();

document.addEventListener("DOMContentLoaded", () => {
    const burgerMenu = document.querySelector('.burger-menu');
    const menuDrawer = document.querySelector('.menu-drawer');

    if (burgerMenu && menuDrawer) {
        burgerMenu.addEventListener("click", () => {
            menuDrawer.classList.toggle("open");

            // ✅ Ensure menu becomes visible
            if (menuDrawer.classList.contains("open")) {
                menuDrawer.style.display = "block"; // Ensure it appears
                document.body.style.overflow = "hidden"; // Prevent scrolling
            } else {
                menuDrawer.style.display = "none";
                document.body.style.overflow = "auto";
            }
        });
    }
});

document.addEventListener("DOMContentLoaded", function () {
    function waitForElement(selector, callback, interval = 100) {
        const checkExist = setInterval(() => {
            const element = document.querySelector(selector);
            if (element) {
                clearInterval(checkExist);
                callback(element);
            }
        }, interval);
    }
});

document.addEventListener("DOMContentLoaded", function () {
    const cartIcon = document.getElementById("cart-icon-bubble");

    if (cartIcon) {
        cartIcon.addEventListener("click", function () {
            window.location.href = "/cart"; // Forces navigation
        });
    }
});

document.addEventListener("DOMContentLoaded", function () {
  const wrapper = document.querySelector('.header__localization');
  const list = document.getElementById('HeaderCountryList');
  const button = wrapper?.querySelector('.header__localization-button');

  if (!wrapper || !list || !button) {
    console.log("❌ Dropdown elements not found");
    return;
  }

  document.addEventListener("click", function (event) {
    const clickedInside = wrapper.contains(event.target);
    const isVisible = list.offsetParent !== null || list.hasAttribute("open") || button.getAttribute("aria-expanded") === "true";

    if (!clickedInside && isVisible) {
      console.log("👋 Hiding the dropdown");

      // Shopify toggles with aria-expanded + hidden
      button.setAttribute("aria-expanded", "false");
      list.setAttribute("hidden", "true");
    }
  });
});

document.addEventListener("DOMContentLoaded", function () {
    document.querySelectorAll('.disclosure__link').forEach(link => {
        // Ensure all links start black
        link.style.color = "black";
    });
});

document.addEventListener("DOMContentLoaded", () => {
    if (window.Shopify && Shopify.designMode) {
        return;
    }

    const headerCountryForm = document.querySelector(
        'localization-form form#HeaderCountryForm'
    );

    if (!headerCountryForm) {
        return;
    }

    const countryInput = headerCountryForm.querySelector(
        'input[name="country_code"]'
    );
    const availableCountryLinks = headerCountryForm.querySelectorAll(
        '.disclosure__link[data-value]'
    );

    if (!countryInput || availableCountryLinks.length <= 1) {
        return;
    }

    const FALLBACK_COUNTRY = 'SG';
    const currentCountry = (countryInput.value || '').toUpperCase();

    const applyCountry = (countryCode) => {
        if (!countryCode) {
            return false;
        }

        const normalizedCode = countryCode.toUpperCase();

        if (!/^[A-Z]{2}$/.test(normalizedCode)) {
            return false;
        }

        if (normalizedCode === currentCountry) {
            return true;
        }

        const matchingLink = headerCountryForm.querySelector(
            `.disclosure__link[data-value="${normalizedCode}"]`
        );

        if (!matchingLink) {
            return false;
        }

        countryInput.value = normalizedCode;
        headerCountryForm.submit();

        return true;
    };

    const fetchCountryFromIp = async () => {
        const controller = new AbortController();
        const timeout = setTimeout(() => controller.abort(), 5000);

        try {
            const response = await fetch(
                'https://ipwho.is/?fields=country_code',
                { signal: controller.signal }
            );

            if (!response.ok) {
                return null;
            }

            const data = await response.json();

            if (data && data.success !== false && data.country_code) {
                return data.country_code;
            }

            return null;
        } catch (error) {
            return null;
        } finally {
            clearTimeout(timeout);
        }
    };

    fetchCountryFromIp().then((resolvedCountry) => {
        if (!applyCountry(resolvedCountry)) {
            applyCountry(FALLBACK_COUNTRY);
        }
    });
});